import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { MobileNav } from './layout/MobileNav';
import { Footer } from './layout/Footer';
import { PressboxNav } from './layout/PressboxNav';
import { BetaBanner } from './feedback/BetaBanner';
import { BetaFeedbackWidget } from './feedback/BetaFeedbackWidget';
import { FeedbackProvider, useFeedbackWidget } from '../contexts/FeedbackContext';
import { BadgeNotificationToast } from './badges/BadgeNotificationToast';
import { UploadScorecardModal } from './scorecards/UploadScorecardModal';

function Layout() {
  return (
    <FeedbackProvider>
      <LayoutInner />
    </FeedbackProvider>
  );
}

function LayoutInner() {
  const { isWidgetOpen, prefillSource, openWidget, closeWidget } = useFeedbackWidget();
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-cream">
      {/* Beta banner above nav */}
      <BetaBanner onFeedbackClick={() => openWidget()} />

      <PressboxNav onUpload={() => setUploadModalOpen(true)} />

      {/* Main content area */}
      <main className="pb-20 md:pb-0">
        <Outlet />
      </main>

      {/* Site footer */}
      <Footer />

      {/* Mobile bottom navigation */}
      <MobileNav onUpload={() => setUploadModalOpen(true)} />
      <UploadScorecardModal isOpen={uploadModalOpen} onClose={() => setUploadModalOpen(false)} />

      {/* Beta feedback widget (floating tab + drawer) */}
      <BetaFeedbackWidget
        isOpen={isWidgetOpen}
        onOpen={() => openWidget()}
        onClose={closeWidget}
        prefillSource={prefillSource}
      />

      {/* Badge notification toasts */}
      <BadgeNotificationToast />
    </div>
  );
}

export default Layout;
